import SavedQueriesTable from './Table';

export default SavedQueriesTable;
